// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== LAYOUT BASE STYLES ===== */
.main {
  padding: 10px 5px;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main.dark {
  background: #1e2d3b;
  color: #fff;
}

.main.light {
  background: #f5f5f5;
  color: #000;
}

.layout {
  height: 100%;
}

/* ===== SIDEBAR STYLES ===== */
.sidebar {
  background-color: #1e2d3b !important;
  border-radius: 5px;
  box-shadow: 0 0 2px grey;
  margin-right: 10px;
  padding: 0;                        /* ← remove top padding; header handles it */
  height: 100vh;
  overflow: hidden;                  /* ← let children handle their own scroll */
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
}


.sidebar.active {
  width: 300px !important;
}

.sidebar.collapsed {
  width: 120px !important;
}

.main.dark .sidebar {
  background-color: #1e2d3b !important;
  border-right-color: #303030;
    box-shadow: 0 0 2px rgb(22, 22, 22);
}

/* ===== TOGGLE BUTTON ===== */
.toggle-btn {
  display: none;
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 99999999999;
  background: none;
  border: none;
  font-size: 30px;
  color: #F7F7F7 !important;
}

:where(.css-dev-only-do-not-override-7ny38l).ant-btn-variant-solid:disabled,
:where(.css-dev-only-do-not-override-7ny38l).ant-btn-variant-solid.ant-btn-disabled {
  color: #F7F7F7 !important;
  box-shadow: none;
}

/* ===== SIDEBAR HEADER ===== */
.sidebar-header {
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: inherit;
  flex-shrink: 0;                    /* ← header should never compress either */
}


/* ===== USER AVATAR DROPDOWN ===== */
.user-avatar-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.user-avatar-wrap:hover {
  background: rgba(30, 45, 59, 0.08);
}

.main.dark .user-avatar-wrap:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* Hide name on small screens, keep avatar */
@media (max-width: 480px) {
  .user-avatar-wrap .user-name {
    display: none;
  }

  .user-avatar-wrap {
    padding: 4px;
  }
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #F7F7F7 !important;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn:hover {
  background: rgba(24, 144, 255, 0.1);
}

.logo-section {
  text-align: center;
  margin-top: 16px;
}

.logo {
  margin: 40px 0px;
  font-size: 60px;
  color: #F7F7F7;
  text-align: center;
  font-weight: bold;
}

.role {
  margin-top: -50px;
  font-size: 14px;
  color: #fee715 !important;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ===== THEME CONTROLS ===== */
.theme-controls {
  margin-top: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.control-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #F7F7F7;
}

.control-item:last-child {
  margin-bottom: 0;
}

/* ===== MENU CONTAINER ===== */
.menu-container {
  flex: 1 1;
  min-height: 0;                     /* ← CRITICAL: lets flex child shrink & scroll */
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;
  margin-top: 0;
}

.custom-menu {
  border: none !important;
  background: transparent !important;
}

.custom-menu .ant-menu-item,
.custom-menu .ant-menu-submenu-title {
  margin: 8px 0 !important;
  border-radius: 8px;
  height: 45px;
  line-height: 45px;
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.716) !important;
}

.custom-menu .ant-menu-item-selected {
  background-color: rgba(255, 255, 255, 0.116) !important;
  color: #F7F7F7 !important;
  font-weight: 500;
  box-shadow: 0 0 2px grey;
}

.custom-menu .ant-menu-item:hover,
.custom-menu .ant-menu-submenu-title:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #fee715 !important;
}

/* Remove all outlines and focus styles */
.custom-menu .ant-menu-item:focus,
.custom-menu .ant-menu-submenu-title:focus,
.custom-menu .ant-menu-item a:focus {
  outline: none !important;
  box-shadow: none !important;
}

.custom-menu .ant-menu-item a {
  text-decoration: none !important;
  outline: none !important;
  box-shadow: none !important;
  color: inherit !important;
}

/* Submenu styles */
.custom-menu .ant-menu-sub {
  background: transparent !important;
}

.custom-menu .ant-menu-sub .ant-menu-item {
  margin: 4px 0 !important;
  padding-left: 40px !important;
}

/* ===== SIDEBAR FOOTER ===== */
.sidebar-footer {
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;                    /* ← never compress the footer */
  background-color: #1e2d3b;        /* ← match sidebar so it doesn't float */
}



.main.dark .sidebar-footer {
  border-top-color: #303030;
  box-shadow: 0 -1px 2px rgb(22, 22, 22);
}


.logout-btn {
  width: 100%;
  text-align: left;
  color: #ff4d4f !important;
  border: none;
  height: 45px;
  border-radius: 8px;
  font-weight: 500;
  background: transparent !important;
}

.logout-btn:hover {
  background: rgba(255, 77, 79, 0.1) !important;
  color: #ff4d4f !important;
}

/* ===== CONTENT AREA ===== */
.content {
  width: 100%;
  height: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  margin-left: 320px;
  transition: margin-left 0.3s ease;
}

.sidebar.collapsed + .content {
  margin-left: 100px;
}

/* ===== HEADER STYLES ===== */
.header {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

.main.dark .header {
  background: #1e2d3b;
  border-bottom-color: #0c131a;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
}

.menu-icon {
  font-size: 24px;
  cursor: pointer;
  color: #1e2d3b !important;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.main.dark .menu-icon{
  color:white!important;
}

.menu-icon:hover {
  background: rgba(30, 45, 59, 0.1);
}

.header-search {
  max-width: 300px;
  width: 100%;
}

.search-input {
  width: 100% !important;
  height: 45px !important;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 25px !important;
  font-size: 14px;
  outline: none;
  box-shadow: 0 4px 6px (0, 0, 0, 0.1);
}


.main.dark  .header-search {
 color: white;
}






.search-input:focus {
  border-color: white;
}

.main.dark .search-input {
  background: #25384b;
  border-color:#0a0f14;
  color: #fff!important;
}

.main.dark .search-input::placeholder {
  background-color: white;
  color: #ffffff!important;
}


main.dark :where(.css-dev-only-do-not-override-1odpy5d).ant-input:placeholder-shown {
    text-overflow: ellipsis;
     color: #ffffff!important;
}


.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-name {
  color: #1e2d3b;
  font-weight: 500;
  font-size: 14px;
}

.main.dark .user-name {
  color: #F7F7F7;
}

/* ===== BODY CONTENT ===== */
.body {
  background-color: white;
  border-radius: 5px;
  height: calc(100vh - 100px);
  width: 100%;
  padding: 20px !important;
  overflow-x: auto !important;
  flex: 1 1;
  overflow-y: auto !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.main.dark .body {
  background:#1e2d3b;
  color: #fff;
}

/* ===== SCROLLBAR STYLING ===== */
.body, .sidebar, .menu-container {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.body::-webkit-scrollbar, 
.sidebar::-webkit-scrollbar,
.menu-container::-webkit-scrollbar {
  width: 6px;
}

.body::-webkit-scrollbar-track, 
.sidebar::-webkit-scrollbar-track,
.menu-container::-webkit-scrollbar-track {
  background: transparent;
}

.body::-webkit-scrollbar-thumb, 
.sidebar::-webkit-scrollbar-thumb,
.menu-container::-webkit-scrollbar-thumb {
  background: #1e2d3b;
  border-radius: 3px;
}

.body:hover::-webkit-scrollbar-thumb, 
.sidebar:hover::-webkit-scrollbar-thumb,
.menu-container:hover::-webkit-scrollbar-thumb {
  background: #1e2d3b;
}

.main.dark .body::-webkit-scrollbar-thumb,
.main.dark .sidebar::-webkit-scrollbar-thumb,
.main.dark .menu-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4);
}

.main.dark .body:hover::-webkit-scrollbar-thumb,
.main.dark .sidebar:hover::-webkit-scrollbar-thumb,
.main.dark .menu-container:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.6);
}

/* ===== MENU ITEM STYLES ===== */
.menu-item {
  cursor: pointer;
  margin-top: 15px;
}

.ms-2 {
  font-size: 18px !important;
  color: #F7F7F7 !important;
}

.menu-item a {
  color: rgba(255, 255, 255, 0.716);
  text-decoration: none;
  font-size: 20px;
  padding: 0 10px;
}

.menu-item a:hover {
  color: #fee715 !important;
}

.menu-item i {
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.716);
}

.menu-item i:hover {
  color: #fee715 !important;
}

.menu-item span {
  font-size: 16px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.716);
}

.active-menu-item {
  background-color: rgba(255, 255, 255, 0.116);
  border-radius: 5px;
  box-shadow: 0 0 2px grey;
  padding: 5px;
  color: white;
}

.close-icon {
  font-size: 30px;
  color: #1e2d3b !important;
  cursor: pointer;
  padding: 10px;
}

.main.dark .close-icon{
    color: white !important;

}

.main.dark .search-bar {
  margin: 2px;
   color: white !important;
}




/* ===== SEARCH BAR ===== */
.search-bar {
  margin: 2px;
}

.report-bar {
  margin: 10px;
  padding: 10px;
}

.report-input {
  width: 100% !important;
  height: 40px !important;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 25px !important;
  font-size: 14px;
  outline: none;
}

.report-input:focus {
  border-color: #1e2d3b;
}

/* ===== CARD STYLES ===== */
.card-name {
  font-size: 20px;
  font-weight: bold;
  color: #1e2d3b;
}

.cards-title-name {
  font-size: 20px;
  color: #1e2d3b;
}

.card-space {
  padding-bottom: 20px !important;
}

.card-style {
  background-color: #F7F7F7 !important;
}

.ant-card-head {
  background-color: #217559 !important;
  color: #101820 !important;
}

.ant-card-head-2 {
  background-color: #1e2d3b !important;
  color: #101820 !important;
}

.ri-user-2-line {
  color: #F7F7F7 !important;
}

.complete-app {
  margin-top: 80px !important;
}

.ant-card-head-title {
  color: #F7F7F7 !important;
}

.page-box {
  background-color: #379777 !important;
  padding: 20px !important;
  color: #f7f7f7 !important;
  border-radius: 5px;
  box-shadow: 0 0 2px grey;
  text-align: center;
  font-size: 20px;
}

.page-box-minimal {
  padding: 5px !important;
  color: #101820 !important;
  text-align: center;
  font-size: 16px;
}

/* ===== STATUS INDICATORS ===== */
.status-indicator {
  padding: 5px 10px;
  border-radius: 3px;
  font-weight: 500;
  color: white;
  text-align: center;
}

.approved-status {
  background-color: green;
  box-shadow: 0 0 2px green;
}

.rejected-status {
  background-color: red;
  box-shadow: 0 0 2px red;
}

.followup-status {
  background-color: blue;
  box-shadow: 0 0 2px blue;
}

.completed-status {
  background-color: gray;
  box-shadow: 0 0 2px gray;
}

.pending-status {
  background-color: #1e2d3b;
  box-shadow: 0 0 2px #1e2d3b;
}

/* ===== ANIMATIONS ===== */
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(5px);
  }
}

.shake {
  animation: shake 0.5s;
}

/* ===== APPOINTMENT ADMIN STYLES ===== */
.appointment-admin-container {
  padding: 16px;
  max-width: 100%;
  overflow-x: hidden;
  background-color: #f9fafb;
}

.controls-row {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.search-input, .status-select {
  width: 100% !important;
  max-width: 300px;
}

.appointment-table {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.appointment-table .ant-table {
  font-size: 14px;
}

.appointment-table .ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 8px;
  white-space: nowrap;
}

.appointment-table .ant-table-tbody > tr > td {
  padding: 12px 8px;
  font-size: 13px;
  line-height: 1.5;
}

.appointment-table .status-indicator {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.appointment-table .approved-status {
  background: #e6ffed;
  color: #2e7d32;
}

.appointment-table .rejected-status {
  background: #ffebee;
  color: #d32f2f;
}

.appointment-table .followup-status {
  background: #e3f2fd;
  color: #1976d2;
}

.appointment-table .completed-status {
  background: #e0f7fa;
  color: #0277bd;
}

.appointment-table .pending-status {
  background: #fff3e0;
  color: #f57c00;
}

.action-modal .ant-modal-content {
  border-radius: 8px;
}

.action-modal .ant-modal-header {
  border-radius: 8px 8px 0 0;
  background: #fafafa;
}

.action-modal .ant-form-item {
  margin-bottom: 16px;
}

.action-modal .ant-form-item-label > label {
  font-weight: 500;
}

.ant-table-container {
  overflow-x: auto;
  max-width: 100%;
}

/* ===== RESPONSIVE DESIGN ===== */
@media screen and (max-width: 768px) {
  .sidebar {
    position: fixed;
    transform: translateX(-100%);
    width: 280px !important;
  }
  
  .sidebar.active {
    transform: translateX(0);
  }

  .sidebar.collapsed {
    transform: translateX(-100%);
  }

  .content {
    margin-left: 0 !important;
  }

  .toggle-btn {
    display: block;
  }

  .header {
    padding: 0 16px;
  }

  .header-search {
    max-width: 200px;
  }

  .body {
    padding: 16px !important;
    height: calc(100vh - 120px);
  }

  .appointment-table .ant-table {
    font-size: 12px;
  }

  .appointment-table .ant-table-thead > tr > th,
  .appointment-table .ant-table-tbody > tr > td {
    padding: 8px 4px;
  }

  .controls-row .ant-col {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .search-input, .status-select {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .header-left {
    gap: 12px;
  }
  
  .header-search {
    display: none;
  }
  
  .body {
    padding: 12px !important;
  }
}

/* ===== GLOBAL FOCUS REMOVAL ===== */
*:focus {
  outline: none !important;
}

a, button, .ant-menu-item, .ant-btn {
  outline: none !important;
  box-shadow: none !important;
}

a:focus, button:focus, .ant-menu-item:focus, .ant-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}


/* Add to your CSS file */
.date-mode-selector {
  transition: all 0.3s ease;
}

.date-mode-selector:hover {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

.clinic-day-tag {
  margin-left: 8px;
  font-size: 12px;
}

:where(.css-dev-only-do-not-override-1odpy5d).ant-btn-color-link.ant-btn-variant-link {
  color: white;
  border-color: #2e7d32;
  background-color: #2e7d32;
}


:where(.css-dev-only-do-not-override-1odpy5d).ant-typography {
  font-family: 'Poppins', sans-serif;
    font-size: 14px;
    box-sizing: border-box;
}


:where(.css-dev-only-do-not-override-1odpy5d).ant-picker-calendar .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, :where(.css-dev-only-do-not-override-1odpy5d).ant-picker-calendar .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, :where(.css-dev-only-do-not-override-1odpy5d).ant-picker-calendar .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
    color: #fff;
    background: #2e7d32!important;
}

.ant-radio-group-solid :where(.css-dev-only-do-not-override-1odpy5d).ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background:  #2e7d32!important;
    border-color:  #2e7d32!important;
    color: white!important;
}`, "",{"version":3,"sources":["webpack://./src/layout.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU,yBAAyB,4CAA4C;EAC/E,aAAa;EACb,gBAAgB,mBAAmB,2CAA2C;EAC9E,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,MAAM;AACR;;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;IACzB,mCAAmC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,cAAc,qBAAqB,0CAA0C;AAC/E;;;AAGA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa,sBAAsB,gDAAgD;EACnF,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;;;EAGE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,cAAc,qBAAqB,gCAAgC;EACnE,yBAAyB,SAAS,wCAAwC;AAC5E;;;;AAIA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,oCAAoC;AACtC;;;AAGA;CACC,YAAY;AACb;;;;;;;AAOA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;;AAGA;IACI,uBAAuB;KACtB,wBAAwB;AAC7B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,wBAAwB;EACxB,2BAA2B;EAC3B,SAAO;EACP,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;EACE,WAAW;GACV,uBAAuB;AAC1B;;;;;AAKA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;IACf,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qCAAqC;AACrC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;;AAGA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;;AAGA;EACE,kCAAkC;IAChC,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,gCAAgC;IAChC,sBAAsB;AAC1B","sourcesContent":["/* ===== LAYOUT BASE STYLES ===== */\r\n.main {\r\n  padding: 10px 5px;\r\n  height: 100vh;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.main.dark {\r\n  background: #1e2d3b;\r\n  color: #fff;\r\n}\r\n\r\n.main.light {\r\n  background: #f5f5f5;\r\n  color: #000;\r\n}\r\n\r\n.layout {\r\n  height: 100%;\r\n}\r\n\r\n/* ===== SIDEBAR STYLES ===== */\r\n.sidebar {\r\n  background-color: #1e2d3b !important;\r\n  border-radius: 5px;\r\n  box-shadow: 0 0 2px grey;\r\n  margin-right: 10px;\r\n  padding: 0;                        /* ← remove top padding; header handles it */\r\n  height: 100vh;\r\n  overflow: hidden;                  /* ← let children handle their own scroll */\r\n  transition: transform 0.3s ease-in-out;\r\n  z-index: 1000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n\r\n.sidebar.active {\r\n  width: 300px !important;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 120px !important;\r\n}\r\n\r\n.main.dark .sidebar {\r\n  background-color: #1e2d3b !important;\r\n  border-right-color: #303030;\r\n    box-shadow: 0 0 2px rgb(22, 22, 22);\r\n}\r\n\r\n/* ===== TOGGLE BUTTON ===== */\r\n.toggle-btn {\r\n  display: none;\r\n  position: fixed;\r\n  top: 15px;\r\n  left: 15px;\r\n  z-index: 99999999999;\r\n  background: none;\r\n  border: none;\r\n  font-size: 30px;\r\n  color: #F7F7F7 !important;\r\n}\r\n\r\n:where(.css-dev-only-do-not-override-7ny38l).ant-btn-variant-solid:disabled,\r\n:where(.css-dev-only-do-not-override-7ny38l).ant-btn-variant-solid.ant-btn-disabled {\r\n  color: #F7F7F7 !important;\r\n  box-shadow: none;\r\n}\r\n\r\n/* ===== SIDEBAR HEADER ===== */\r\n.sidebar-header {\r\n  padding: 16px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: inherit;\r\n  flex-shrink: 0;                    /* ← header should never compress either */\r\n}\r\n\r\n\r\n/* ===== USER AVATAR DROPDOWN ===== */\r\n.user-avatar-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  transition: background 0.2s ease;\r\n  user-select: none;\r\n}\r\n\r\n.user-avatar-wrap:hover {\r\n  background: rgba(30, 45, 59, 0.08);\r\n}\r\n\r\n.main.dark .user-avatar-wrap:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n/* Hide name on small screens, keep avatar */\r\n@media (max-width: 480px) {\r\n  .user-avatar-wrap .user-name {\r\n    display: none;\r\n  }\r\n\r\n  .user-avatar-wrap {\r\n    padding: 4px;\r\n  }\r\n}\r\n\r\n.toggle-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: #F7F7F7 !important;\r\n  padding: 8px;\r\n  border-radius: 6px;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.toggle-btn:hover {\r\n  background: rgba(24, 144, 255, 0.1);\r\n}\r\n\r\n.logo-section {\r\n  text-align: center;\r\n  margin-top: 16px;\r\n}\r\n\r\n.logo {\r\n  margin: 40px 0px;\r\n  font-size: 60px;\r\n  color: #F7F7F7;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.role {\r\n  margin-top: -50px;\r\n  font-size: 14px;\r\n  color: #fee715 !important;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n/* ===== THEME CONTROLS ===== */\r\n.theme-controls {\r\n  margin-top: 16px;\r\n  padding: 12px;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-radius: 8px;\r\n}\r\n\r\n.control-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n  font-size: 12px;\r\n  color: #F7F7F7;\r\n}\r\n\r\n.control-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* ===== MENU CONTAINER ===== */\r\n.menu-container {\r\n  flex: 1;\r\n  min-height: 0;                     /* ← CRITICAL: lets flex child shrink & scroll */\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 8px 0;\r\n  margin-top: 0;\r\n}\r\n\r\n.custom-menu {\r\n  border: none !important;\r\n  background: transparent !important;\r\n}\r\n\r\n.custom-menu .ant-menu-item,\r\n.custom-menu .ant-menu-submenu-title {\r\n  margin: 8px 0 !important;\r\n  border-radius: 8px;\r\n  height: 45px;\r\n  line-height: 45px;\r\n  transition: all 0.3s ease;\r\n  color: rgba(255, 255, 255, 0.716) !important;\r\n}\r\n\r\n.custom-menu .ant-menu-item-selected {\r\n  background-color: rgba(255, 255, 255, 0.116) !important;\r\n  color: #F7F7F7 !important;\r\n  font-weight: 500;\r\n  box-shadow: 0 0 2px grey;\r\n}\r\n\r\n.custom-menu .ant-menu-item:hover,\r\n.custom-menu .ant-menu-submenu-title:hover {\r\n  background: rgba(255, 255, 255, 0.1) !important;\r\n  color: #fee715 !important;\r\n}\r\n\r\n/* Remove all outlines and focus styles */\r\n.custom-menu .ant-menu-item:focus,\r\n.custom-menu .ant-menu-submenu-title:focus,\r\n.custom-menu .ant-menu-item a:focus {\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.custom-menu .ant-menu-item a {\r\n  text-decoration: none !important;\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n  color: inherit !important;\r\n}\r\n\r\n/* Submenu styles */\r\n.custom-menu .ant-menu-sub {\r\n  background: transparent !important;\r\n}\r\n\r\n.custom-menu .ant-menu-sub .ant-menu-item {\r\n  margin: 4px 0 !important;\r\n  padding-left: 40px !important;\r\n}\r\n\r\n/* ===== SIDEBAR FOOTER ===== */\r\n.sidebar-footer {\r\n  padding: 12px 16px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n  flex-shrink: 0;                    /* ← never compress the footer */\r\n  background-color: #1e2d3b;        /* ← match sidebar so it doesn't float */\r\n}\r\n\r\n\r\n\r\n.main.dark .sidebar-footer {\r\n  border-top-color: #303030;\r\n  box-shadow: 0 -1px 2px rgb(22, 22, 22);\r\n}\r\n\r\n\r\n.logout-btn {\r\n  width: 100%;\r\n  text-align: left;\r\n  color: #ff4d4f !important;\r\n  border: none;\r\n  height: 45px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  background: transparent !important;\r\n}\r\n\r\n.logout-btn:hover {\r\n  background: rgba(255, 77, 79, 0.1) !important;\r\n  color: #ff4d4f !important;\r\n}\r\n\r\n/* ===== CONTENT AREA ===== */\r\n.content {\r\n  width: 100%;\r\n  height: 100%;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  margin-left: 320px;\r\n  transition: margin-left 0.3s ease;\r\n}\r\n\r\n.sidebar.collapsed + .content {\r\n  margin-left: 100px;\r\n}\r\n\r\n/* ===== HEADER STYLES ===== */\r\n.header {\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 20px;\r\n  height: 80px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 24px;\r\n}\r\n\r\n.main.dark .header {\r\n  background: #1e2d3b;\r\n  border-bottom-color: #0c131a;\r\n}\r\n\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex: 1;\r\n}\r\n\r\n.menu-icon {\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #1e2d3b !important;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.main.dark .menu-icon{\r\n  color:white!important;\r\n}\r\n\r\n.menu-icon:hover {\r\n  background: rgba(30, 45, 59, 0.1);\r\n}\r\n\r\n.header-search {\r\n  max-width: 300px;\r\n  width: 100%;\r\n}\r\n\r\n.search-input {\r\n  width: 100% !important;\r\n  height: 45px !important;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 25px !important;\r\n  font-size: 14px;\r\n  outline: none;\r\n  box-shadow: 0 4px 6px (0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.main.dark  .header-search {\r\n color: white;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.search-input:focus {\r\n  border-color: white;\r\n}\r\n\r\n.main.dark .search-input {\r\n  background: #25384b;\r\n  border-color:#0a0f14;\r\n  color: #fff!important;\r\n}\r\n\r\n.main.dark .search-input::placeholder {\r\n  background-color: white;\r\n  color: #ffffff!important;\r\n}\r\n\r\n\r\nmain.dark :where(.css-dev-only-do-not-override-1odpy5d).ant-input:placeholder-shown {\r\n    text-overflow: ellipsis;\r\n     color: #ffffff!important;\r\n}\r\n\r\n\r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.user-name {\r\n  color: #1e2d3b;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n}\r\n\r\n.main.dark .user-name {\r\n  color: #F7F7F7;\r\n}\r\n\r\n/* ===== BODY CONTENT ===== */\r\n.body {\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  height: calc(100vh - 100px);\r\n  width: 100%;\r\n  padding: 20px !important;\r\n  overflow-x: auto !important;\r\n  flex: 1;\r\n  overflow-y: auto !important;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.main.dark .body {\r\n  background:#1e2d3b;\r\n  color: #fff;\r\n}\r\n\r\n/* ===== SCROLLBAR STYLING ===== */\r\n.body, .sidebar, .menu-container {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: transparent transparent;\r\n}\r\n\r\n.body::-webkit-scrollbar, \r\n.sidebar::-webkit-scrollbar,\r\n.menu-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.body::-webkit-scrollbar-track, \r\n.sidebar::-webkit-scrollbar-track,\r\n.menu-container::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.body::-webkit-scrollbar-thumb, \r\n.sidebar::-webkit-scrollbar-thumb,\r\n.menu-container::-webkit-scrollbar-thumb {\r\n  background: #1e2d3b;\r\n  border-radius: 3px;\r\n}\r\n\r\n.body:hover::-webkit-scrollbar-thumb, \r\n.sidebar:hover::-webkit-scrollbar-thumb,\r\n.menu-container:hover::-webkit-scrollbar-thumb {\r\n  background: #1e2d3b;\r\n}\r\n\r\n.main.dark .body::-webkit-scrollbar-thumb,\r\n.main.dark .sidebar::-webkit-scrollbar-thumb,\r\n.main.dark .menu-container::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.main.dark .body:hover::-webkit-scrollbar-thumb,\r\n.main.dark .sidebar:hover::-webkit-scrollbar-thumb,\r\n.main.dark .menu-container:hover::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n/* ===== MENU ITEM STYLES ===== */\r\n.menu-item {\r\n  cursor: pointer;\r\n  margin-top: 15px;\r\n}\r\n\r\n.ms-2 {\r\n  font-size: 18px !important;\r\n  color: #F7F7F7 !important;\r\n}\r\n\r\n.menu-item a {\r\n  color: rgba(255, 255, 255, 0.716);\r\n  text-decoration: none;\r\n  font-size: 20px;\r\n  padding: 0 10px;\r\n}\r\n\r\n.menu-item a:hover {\r\n  color: #fee715 !important;\r\n}\r\n\r\n.menu-item i {\r\n  margin: 0 10px;\r\n  color: rgba(255, 255, 255, 0.716);\r\n}\r\n\r\n.menu-item i:hover {\r\n  color: #fee715 !important;\r\n}\r\n\r\n.menu-item span {\r\n  font-size: 16px;\r\n  text-decoration: none;\r\n  color: rgba(255, 255, 255, 0.716);\r\n}\r\n\r\n.active-menu-item {\r\n  background-color: rgba(255, 255, 255, 0.116);\r\n  border-radius: 5px;\r\n  box-shadow: 0 0 2px grey;\r\n  padding: 5px;\r\n  color: white;\r\n}\r\n\r\n.close-icon {\r\n  font-size: 30px;\r\n  color: #1e2d3b !important;\r\n  cursor: pointer;\r\n  padding: 10px;\r\n}\r\n\r\n.main.dark .close-icon{\r\n    color: white !important;\r\n\r\n}\r\n\r\n.main.dark .search-bar {\r\n  margin: 2px;\r\n   color: white !important;\r\n}\r\n\r\n\r\n\r\n\r\n/* ===== SEARCH BAR ===== */\r\n.search-bar {\r\n  margin: 2px;\r\n}\r\n\r\n.report-bar {\r\n  margin: 10px;\r\n  padding: 10px;\r\n}\r\n\r\n.report-input {\r\n  width: 100% !important;\r\n  height: 40px !important;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 25px !important;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.report-input:focus {\r\n  border-color: #1e2d3b;\r\n}\r\n\r\n/* ===== CARD STYLES ===== */\r\n.card-name {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #1e2d3b;\r\n}\r\n\r\n.cards-title-name {\r\n  font-size: 20px;\r\n  color: #1e2d3b;\r\n}\r\n\r\n.card-space {\r\n  padding-bottom: 20px !important;\r\n}\r\n\r\n.card-style {\r\n  background-color: #F7F7F7 !important;\r\n}\r\n\r\n.ant-card-head {\r\n  background-color: #217559 !important;\r\n  color: #101820 !important;\r\n}\r\n\r\n.ant-card-head-2 {\r\n  background-color: #1e2d3b !important;\r\n  color: #101820 !important;\r\n}\r\n\r\n.ri-user-2-line {\r\n  color: #F7F7F7 !important;\r\n}\r\n\r\n.complete-app {\r\n  margin-top: 80px !important;\r\n}\r\n\r\n.ant-card-head-title {\r\n  color: #F7F7F7 !important;\r\n}\r\n\r\n.page-box {\r\n  background-color: #379777 !important;\r\n  padding: 20px !important;\r\n  color: #f7f7f7 !important;\r\n  border-radius: 5px;\r\n  box-shadow: 0 0 2px grey;\r\n  text-align: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.page-box-minimal {\r\n  padding: 5px !important;\r\n  color: #101820 !important;\r\n  text-align: center;\r\n  font-size: 16px;\r\n}\r\n\r\n/* ===== STATUS INDICATORS ===== */\r\n.status-indicator {\r\n  padding: 5px 10px;\r\n  border-radius: 3px;\r\n  font-weight: 500;\r\n  color: white;\r\n  text-align: center;\r\n}\r\n\r\n.approved-status {\r\n  background-color: green;\r\n  box-shadow: 0 0 2px green;\r\n}\r\n\r\n.rejected-status {\r\n  background-color: red;\r\n  box-shadow: 0 0 2px red;\r\n}\r\n\r\n.followup-status {\r\n  background-color: blue;\r\n  box-shadow: 0 0 2px blue;\r\n}\r\n\r\n.completed-status {\r\n  background-color: gray;\r\n  box-shadow: 0 0 2px gray;\r\n}\r\n\r\n.pending-status {\r\n  background-color: #1e2d3b;\r\n  box-shadow: 0 0 2px #1e2d3b;\r\n}\r\n\r\n/* ===== ANIMATIONS ===== */\r\n@keyframes shake {\r\n  0%, 100% {\r\n    transform: translateX(0);\r\n  }\r\n  10%, 30%, 50%, 70%, 90% {\r\n    transform: translateX(-5px);\r\n  }\r\n  20%, 40%, 60%, 80% {\r\n    transform: translateX(5px);\r\n  }\r\n}\r\n\r\n.shake {\r\n  animation: shake 0.5s;\r\n}\r\n\r\n/* ===== APPOINTMENT ADMIN STYLES ===== */\r\n.appointment-admin-container {\r\n  padding: 16px;\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.controls-row {\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n}\r\n\r\n.search-input, .status-select {\r\n  width: 100% !important;\r\n  max-width: 300px;\r\n}\r\n\r\n.appointment-table {\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.appointment-table .ant-table {\r\n  font-size: 14px;\r\n}\r\n\r\n.appointment-table .ant-table-thead > tr > th {\r\n  background: #fafafa;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  padding: 12px 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.appointment-table .ant-table-tbody > tr > td {\r\n  padding: 12px 8px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.appointment-table .status-indicator {\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.appointment-table .approved-status {\r\n  background: #e6ffed;\r\n  color: #2e7d32;\r\n}\r\n\r\n.appointment-table .rejected-status {\r\n  background: #ffebee;\r\n  color: #d32f2f;\r\n}\r\n\r\n.appointment-table .followup-status {\r\n  background: #e3f2fd;\r\n  color: #1976d2;\r\n}\r\n\r\n.appointment-table .completed-status {\r\n  background: #e0f7fa;\r\n  color: #0277bd;\r\n}\r\n\r\n.appointment-table .pending-status {\r\n  background: #fff3e0;\r\n  color: #f57c00;\r\n}\r\n\r\n.action-modal .ant-modal-content {\r\n  border-radius: 8px;\r\n}\r\n\r\n.action-modal .ant-modal-header {\r\n  border-radius: 8px 8px 0 0;\r\n  background: #fafafa;\r\n}\r\n\r\n.action-modal .ant-form-item {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.action-modal .ant-form-item-label > label {\r\n  font-weight: 500;\r\n}\r\n\r\n.ant-table-container {\r\n  overflow-x: auto;\r\n  max-width: 100%;\r\n}\r\n\r\n/* ===== RESPONSIVE DESIGN ===== */\r\n@media screen and (max-width: 768px) {\r\n  .sidebar {\r\n    position: fixed;\r\n    transform: translateX(-100%);\r\n    width: 280px !important;\r\n  }\r\n  \r\n  .sidebar.active {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .sidebar.collapsed {\r\n    transform: translateX(-100%);\r\n  }\r\n\r\n  .content {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .toggle-btn {\r\n    display: block;\r\n  }\r\n\r\n  .header {\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .header-search {\r\n    max-width: 200px;\r\n  }\r\n\r\n  .body {\r\n    padding: 16px !important;\r\n    height: calc(100vh - 120px);\r\n  }\r\n\r\n  .appointment-table .ant-table {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .appointment-table .ant-table-thead > tr > th,\r\n  .appointment-table .ant-table-tbody > tr > td {\r\n    padding: 8px 4px;\r\n  }\r\n\r\n  .controls-row .ant-col {\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .search-input, .status-select {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .header-left {\r\n    gap: 12px;\r\n  }\r\n  \r\n  .header-search {\r\n    display: none;\r\n  }\r\n  \r\n  .body {\r\n    padding: 12px !important;\r\n  }\r\n}\r\n\r\n/* ===== GLOBAL FOCUS REMOVAL ===== */\r\n*:focus {\r\n  outline: none !important;\r\n}\r\n\r\na, button, .ant-menu-item, .ant-btn {\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\na:focus, button:focus, .ant-menu-item:focus, .ant-btn:focus {\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n\r\n/* Add to your CSS file */\r\n.date-mode-selector {\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.date-mode-selector:hover {\r\n  border-color: #1890ff;\r\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);\r\n}\r\n\r\n.clinic-day-tag {\r\n  margin-left: 8px;\r\n  font-size: 12px;\r\n}\r\n\r\n:where(.css-dev-only-do-not-override-1odpy5d).ant-btn-color-link.ant-btn-variant-link {\r\n  color: white;\r\n  border-color: #2e7d32;\r\n  background-color: #2e7d32;\r\n}\r\n\r\n\r\n:where(.css-dev-only-do-not-override-1odpy5d).ant-typography {\r\n  font-family: 'Poppins', sans-serif;\r\n    font-size: 14px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n\r\n:where(.css-dev-only-do-not-override-1odpy5d).ant-picker-calendar .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, :where(.css-dev-only-do-not-override-1odpy5d).ant-picker-calendar .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, :where(.css-dev-only-do-not-override-1odpy5d).ant-picker-calendar .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {\r\n    color: #fff;\r\n    background: #2e7d32!important;\r\n}\r\n\r\n.ant-radio-group-solid :where(.css-dev-only-do-not-override-1odpy5d).ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\r\n    color: #fff;\r\n    background:  #2e7d32!important;\r\n    border-color:  #2e7d32!important;\r\n    color: white!important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
